import { useCallback, useEffect, useState } from 'react';
import { useTreeDndUiStore } from '@/components/tree-dnd/tree-dnd-ui-store';

export function useConditionEditSheet(nodeId: string) {
  const [open, setOpen] = useState(false);
  const editingConditionId = useTreeDndUiStore(
    (state) => state.editingConditionId
  );
  const clearConditionEditor = useTreeDndUiStore(
    (state) => state.clearConditionEditor
  );
  const suppressConditionActivate = useTreeDndUiStore(
    (state) => state.suppressConditionActivate
  );

  useEffect(() => {
    if (editingConditionId === nodeId) {
      setOpen(true);
      clearConditionEditor();
    }
  }, [clearConditionEditor, editingConditionId, nodeId]);

  const onOpenChange = useCallback(
    (nextOpen: boolean) => {
      if (!nextOpen) {
        suppressConditionActivate();
      }
      setOpen(nextOpen);
    },
    [suppressConditionActivate]
  );

  return {
    open,
    onOpenChange,
    openEditor: () => setOpen(true),
  };
}
